<template>
  <div>
    LEAVE ALL EMPLOYEE
    <hr>
    <b-form-group :class="{'error-input' : $v.data_form.title.$error}">
      <label> Leave All Employee Title </label>
      <j-input
        v-model="$v.data_form.title.$model"
        :max-length="255"
        placeholder="Leave All Employee Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_form.monitor.$error}">
      <label> Monitor </label>
      <j-single-select
        v-model="$v.data_form.monitor.$model"
        :options="list_monitor"
        placeholder="Select Monitor"
        label="name"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeForm">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveForm">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_form: {
      title: {
        required,
      },
      monitor: {
        required,
      },
    },
  },
  data() {
    return {
      data_form: {
        title: '',
        monitor: null,
      },
      list_monitor: [
        { id: 'all_employee', name: 'All Employee' },
        { id: 'by_restriction', name: 'By Restriction' },
      ],
    };
  },
  computed: {
    generateData() {
      const data = {
        info: JSON.stringify({
          name: this.data_form.title,
          monitor: this.data_form.monitor,
        }),
        name: this.data_form.title,
        widget_master_id: this.dataMaster.id,

        type: 1,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataUpdate() {
      const data = {
        info: JSON.stringify({
          name: this.data_form.title,
          monitor: this.data_form.monitor,
        }),
        name: this.data_form.title,
        widget_master_id: this.dataMaster.id,

        type: 1,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_form.title = JSON.parse(this.dataEdit.info).name;
      this.data_form.monitor = JSON.parse(this.dataEdit.info).monitor;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),

    saveForm() {
      this.$v.data_form.$touch();
      if (!this.$v.data_form.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateData;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataUpdate;
          this.updateWidget({ widgetId, dataParam });
        }
        this.closeForm();
      }
    },

    closeForm() {
      this.$emit('close-field');
      this.data_form.title = null;
      setTimeout(() => {
        this.$v.data_form.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jLeaveAllEmployeeSetup.vue